import styled from 'styled-components'

export const SettingWrapper = styled.div<{IsMobile?:boolean}>`
  display: flex;
  flex-direction: ${(props) => props.IsMobile ? 'column' : 'row'};
  gap: 16px;
  width: 100%;
`
export const SettingMaster = styled.div`
  box-shadow: 2px 2px 8px 2px #74747476;
  background-color: #fff;
  padding: 28px;
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 16px;
`
export const SettingSite = styled.div`
  box-shadow: 2px 2px 8px 2px #74747476;
  background-color: #fff;
  padding: 28px;
  flex: 2;
  display: flex;
  flex-direction: column;
  gap: 22px;
`
export const SettingHeader = styled.p`
  font-size: 16px;
  font-weight: 700;
  color: #010101;
  margin-bottom: 30px;
`
export const SettingInput = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  label {
    font-size: 15px;
    font-weight: 400;
    color: #101010;
    user-select: none;
  }
`
export const SiteManageFooter = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`
export const SettingSwitch = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  label {
    font-size: 15px;
    font-weight: 400;
    color: #101010;
    user-select: none;
  }
`
export const SettingSubmit = styled.button`
  background-color: #0d6efd;
  border-radius: 4px;
  border: none;
  padding: 8px 12px;
  font-family: Pretendard;
  color: #fff;
  font-size: 16px;
  width: 100px;
  margin-top: 20px;
`